import { Link_T } from "./link";

export function parseLinkProps<T>(props: Link_T & T) {
  const {
    href,
    replace,
    scroll,
    shallow,
    passHref,
    prefetch,
    locale,
    isExternal,
    isOverlay,
    ...rest
  } = props;
  const linkProps = {
    href,
    replace,
    scroll,
    shallow,
    passHref,
    prefetch,
    locale,
    isExternal,
    isOverlay,
  };
  return { linkProps, rest } as { linkProps: Link_T; rest: T };
}
